module.exports = __webpack_public_path__ + "img/scales-02.0a36ccad.svg";